import React from 'react'
import { Container, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'



const Cards = ({ site }) => {


    const onClickHandler = () => {

        localStorage.setItem('finallink', localStorage.getItem('link') + site.link)

    }




    return (

        <Container onClick={onClickHandler}>
            <Link to="backToPast/">

                <Container className="py-4 rounded bg-white" style={{ textAlign: 'center', marginBottom: '3rem' }}>

                    <Image src={site.image} rounded style={{ width: '200px', height: '60px' }} />

                </Container></Link></Container>


    )
}

export default Cards
